import { useTranslation } from "react-i18next";
import { Navbar, Button, Container, Row, Col, Nav, Image } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faInstagram, faLinkedin, faDev, faTwitter, faMedium } from '@fortawesome/free-brands-svg-icons';
import { faUpRightFromSquare, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import footerCSS from './css/footer.css';
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ImpressumView } from '../impressum-view/impressum-view';

export const Footer = () =>{
  const { t } = useTranslation();
	const footer = [
		{
		  title: t("footer.copy"),
		  // ...
		},
	  ];
    function toggleSidebar() {
      let sidebar = document.querySelector('.social-container');
      let menuClose = document.querySelector('.fa-caret-right');
      let sidebarState = localStorage.getItem("sidebarState");
  
      if (sidebarState === "closed" || !sidebarState) {
          // Show the sidebar
          sidebar.style.left = "0px";
          menuClose.style.transform = "rotate(180deg)";
          localStorage.setItem("sidebarState", "open");
      } else {
          // Hide the sidebar
          sidebar.style.left = "-37px";
          menuClose.style.transform = "none";
          localStorage.setItem("sidebarState", "closed");
      }
  }

  function showSidebar() {
    let sidebar = document.querySelector('.social-container');

      let sidebarState = localStorage.getItem("sidebarState");
    // let menuBars = document.querySelector('.fa-arrow-right');
    // let menuClose = document.querySelector('.close-sidebar');
    let menuClose = document.querySelector('.fa-caret-right');
    
    sidebar.style.left = "0px";
    menuClose.style.transform = "rotate(180deg)";
    localStorage.setItem("sidebarState", "open");
      menuClose.style.display = "inline";
      sidebar.style.transition = "all 0.4s ease-in-out";
      menuClose.style.transition = "all 0.1s ease-in-out";

      
    }
  
  
  // Restore sidebar state using useEffect when the component mounts
  useEffect(() => {
      let sidebar = document.querySelector('.social-container');
      let menuClose = document.querySelector('.fa-caret-right');
      let sidebarState = localStorage.getItem("sidebarState");
  
      if (sidebarState === "open") {
          sidebar.style.left = "0px";
          menuClose.style.transform = "rotate(180deg)";
      } else {
          sidebar.style.left = "-37px";
          menuClose.style.transform = "none";
      }
  }, []);
    return (
    <>
<footer className="main-footer footer-404 pt-5 pb-4 w-100">
    
    <div className="social-container" 
    onMouseEnter={()=>{showSidebar()}}
    >
        <div className="sidebar-close fixed-ltr">
            <Button title={t("footer.toggleTitle")}
            className="sidebar-toggler sidebar-pulse " onClick={()=>toggleSidebar()}>
                <label className="" for="sidebar">
                    
                    {/* <i className="fa-solid fa-xl fa-caret-right close-sidebar"></i> */}
                    <FontAwesomeIcon className="fa-solid fa-caret-right fa-xl close-sidebar " icon={faChevronRight} />
                </label>
            </Button>
        </div>
        
        <Link title={t("footerDevTitle")} to='https://dev.to/yevheniiairapetian' target="_blank" rel="noopener"><FontAwesomeIcon title={t("footerDevTitle")} className="fa-dev" icon={faDev}/></Link>
        <Link title={t("footerTwitTitle")} to='https://twitter.com/airapetian_dev' target="_blank" rel="noopener"><FontAwesomeIcon title={t("footerTwitTitle")} className="fa-twitter" icon={faTwitter} /></Link>
        <Link title={t("footerGitTitle")} to='https://github.com/yevheniiairapetian' target="_blank" rel="noopener"><FontAwesomeIcon  title={t("footerGitTitle")} className="fa-github" icon={faGithub} /></Link>
        <Link title={t("footerLinkedTitle")} to='https://www.linkedin.com/in/yevheniiairapetian/' target="_blank" rel="noopener"><FontAwesomeIcon title={t("footerLinkedTitle")} className="fa-linkedin" icon={faLinkedin} /></Link>

        {/* <Link title={t("footerBlogTitle")} to='https://www.nerdybrace.com' className="blog-link" target="_blank" rel="noopener"><FontAwesomeIcon title={t("footerBlogTitle")} icon={faUpRightFromSquare} className="fa-arrow-up-right" /></Link> */}
        {/* <Link title={t("footerInstaTitle")} to='https://www.instagram.com/n3rdybrace' className="instagram"  target="_blank" rel="noopener"><FontAwesomeIcon  title={t("footerInstaTitle")} icon={faInstagram} className="fa-instagram" /></Link> */}
        <Link title={t("footerMediumTitle")} to='https://medium.com/@yevheniiairapetian' className="medium" target="_blank" rel="noopener"><FontAwesomeIcon title={t("footerMediumTitle")} className="fa-medium" icon={faMedium} /></Link>


    </div>
    <p className="fade-in-up-on-scroll copyright text-center">{t("footer.copy")}</p>
    <div className="footer-links-container">
   
    <Nav.Link className="text-light footer-links" as={Link} to={"https://www.freeprivacypolicy.com/live/13aaa5dd-c830-46ce-8e8a-010efe1a66f1"} target="_blank" >{t("menu.cookies")}</Nav.Link>
    <Nav.Link className="text-light footer-links" as={Link} to='/impressum'>{t("footer.impressumFooter")}</Nav.Link>
    <Nav.Link className="text-light footer-links" as={Link} to={"https://www.freeprivacypolicy.com/live/c361241a-8f0b-4be3-8d44-56ba30ba476a"} target="_blank" >{t("menu.privacy")}</Nav.Link>
    </div>
    {/* <Link to={ImpressumView} className="impressum fade-in-up-on-scroll" >Impressum</Link> */}


</footer>
</>

  
    );
};


